import React, { FC, KeyboardEvent, useMemo } from "react";
import Input from "../input/Input";
import { FieldHorizontal } from "../form/Form";
import classNames from "classnames";
import {
  ComposantAllProps,
  ColorProps,
  SizeProps,
  getColorsClasses,
  getSizeClasses,
} from "composants/common";

import { format, isValid, parseISO } from "date-fns";
import { useMacOSDatePicker } from "utils/platform.utils";
import { toNearestMidnight, toLocalDate } from "composants/datatableAGGrid/utils/dateUtils";

export interface CalendarProps extends ComposantAllProps {
  defaultAppearance?: boolean;
}

const Calendar = ({ value, defaultAppearance, ...restProps }: CalendarProps) => {
  const date = toLocalDate(value);
  const finalValue = useMemo(
    () => (date ? format(toNearestMidnight(date), "yyyy-MM-dd") : ""),
    [date],
  );
  const { inputRef, isMacOS, handleFocus, handleMouseDown } = useMacOSDatePicker();

  // Gestionnaire de touche Tab pour s'assurer que le focus déclenche un événement de validation
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    // Si on appuie sur Tab, on s'assure de déclencher un onBlur pour activer le WVI
    if (e.key === "Tab" && restProps.onBlur) {
      restProps.onBlur(e as any);
    }
    // On propage au gestionnaire d'événement parent s'il existe
    if (restProps.onKeyDown) {
      restProps.onKeyDown(e as any);
    }
  };

  return (
    <Input
      {...restProps}
      ref={inputRef}
      data-initial-appearance={defaultAppearance || isMacOS}
      type="date"
      value={finalValue}
      data-value={finalValue}
      onKeyDown={handleKeyDown as any}
      onFocus={(e) => handleFocus(e, restProps.onFocus)}
      onMouseDown={(e) => handleMouseDown(e, restProps.onMouseDown)}
    />
  );
};

export default Calendar;
